import { TableCell, TableHead, TableRow } from '~/UIKit';
import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';
import {
  CHARCOAL_GREY,
  combinedColor,
  GRAY_LIGHT_2,
  OPACITY_DARK,
  OPACITY_MEDIUM,
} from '~/Constants/Colors.constants';
import { TableDefinition } from '~/Components/DataTable/DataTable.types';
import { useDataTableHook } from '~/Components/DataTable/DataTable.container';

export type DataTableHeaderProps = {
  desktopView?: {
    items: any[];
    tableDefinition: TableDefinition;
    onRowClicked?: (row: any) => void;
  };
};

const useStyles = (hideColumnHeaders: boolean) =>
  makeStyles(() => ({
    header: {
      display: hideColumnHeaders ? 'none' : 'table-header-group',
    },
    head: {
      color: combinedColor(CHARCOAL_GREY, OPACITY_DARK),
      fontSize: FONT_SIZE_SMALL,
      fontWeight: 300,
      paddingBottom: 12,
      paddingTop: 12,
      lineHeight: '16px',
      borderBottom: `1px solid ${combinedColor(GRAY_LIGHT_2, OPACITY_MEDIUM)}`,
    },
  }));

export const DataTableHeader = ({ desktopView }: DataTableHeaderProps) => {
  const hideColumnsHeaders = !!desktopView?.tableDefinition.config?.hideColumnsHeaders;
  const data = desktopView?.items;
  const { rows, columns } = useDataTableHook(data, desktopView?.tableDefinition!);
  const { classes } = useStyles(hideColumnsHeaders)();

  return (
    <TableHead className={classes.header}>
      <TableRow>
        <>
          {columns.map((header, index) => (
            <TableCell style={header.style} className={classes.head} key={index}>
              {header?.headerComponent?.()}
              {header.label}
            </TableCell>
          ))}
          {rows.some(({ rowData }) => rowData?.actions?.length) && (
            <TableCell className={classes.head} style={{ width: 40 }} />
          )}
        </>
      </TableRow>
    </TableHead>
  );
};
